import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';

/**
 * Custom hook to call schema api
 * @returns promise
 */
const useEvent = () => {
  async function callGetEventApi(eName: string, eStatus: string[], exactNameMatch: boolean) {
    const requestBody = {
      events: [{
        eventName: eName
      }],
      exactNameMatch,
      status: eStatus,
      fromDate: '',
      toDate: '',
    };
    const { responseBody, isError, error, statusCode } = await apiWrapper.post<{ totalRecords: number; }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/search`,
      requestBody,
      headersInstance()
    );

    if (isError) {
      throw error;
    }

    return {
      data: responseBody,
      status: statusCode
    };
  }

  const getEventByNameAndMultipleStatus = (eName: string, status: string[], exactNameMatch: boolean) => callGetEventApi(eName, status, exactNameMatch);

  return { getEventByNameAndMultipleStatus };
};

export default useEvent;
